import {Partenaire} from '../../../shared/models/partenaire.model';
import {PartenaireService} from '../../../shared/services/partenaire.service';
import {PartenaireNewComponent} from '../partenaire-new/partenaire-new.component';
import {Component, OnInit, ViewChild} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DataTableResource, DataTable, DataTableTranslations} from 'angular-datatables-all-versions';
import {ToastyService} from 'ng2-toasty';

@Component({
  selector: 'app-partenaires-list',
  templateUrl: './partenaires-list.component.html',
  styleUrls: ['./partenaires-list.component.css']
})
export class PartenairesListComponent implements OnInit {
  partners: any[];
  partnerCount = 0;
  partnerResource: DataTableResource<Object>;

  @ViewChild(DataTable,{static:false}) userTable: DataTable;

  translations = <DataTableTranslations>{
    indexColumn: 'Index column',
    expandColumn: 'Expand column',
    selectColumn: 'Select column',
    paginationLimit: 'Max results',
    paginationRange: 'Result range'
  }

  constructor(private router: Router, private route: ActivatedRoute,
    private toastyService: ToastyService, private modalService: NgbModal, private service: PartenaireService) {
    this.partners = this.route.snapshot.data['partners'];
    this.partnerResource = new DataTableResource(this.partners);
  }

  ngOnInit() {
    this.partnerResource.count().then(count => this.partnerCount = count);
  }

  reloadPartners(params) {
    this.partnerResource.query(params).then(items => this.partners = items);
  }

  onEditPartner(partner: Partenaire) {
    this.router.navigate(['/partenaires', partner.id]);
  }

  cellColor(car) {
    return 'rgb(255, 255,' + (155 + Math.floor(100 - ((car.rating - 8.7) / 1.3) * 100)) + ')';
  }

  onCreatePartner() {
    const modalRef = this.modalService.open(PartenaireNewComponent);
    modalRef.result.then((result) => {
      if ('user-modal-success' === result) {
        // reload table
        this.reloadPartners({sortBy: 'id', sortAsc: true, offset: 0, limit: 8});
        this.toastyService.success({
          title: 'Success',
          msg: 'Manager cr&eacute&eacute',
          showClose: true,
          timeout: 5000,
          theme: 'bootstrap',
        })
      }
    });
  }

}
